import type { z } from "zod";

import { zOutSchema2 } from "./common";

import { Response } from "~/shared/api";

const zRes200 = Response.Schema.zSuccessful(200, zOutSchema2);
const zRes401 = Response.Schema.zNoBody(401);
const zRes404 = Response.Schema.zUnsuccessful(404);

const zRes = Response.Schema.zAggregated([zRes200, zRes401, zRes404]);
type Res = z.infer<typeof zRes>;

export { zRes };
export type { Res };
